import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import { readPendingRequest } from './PendingRequestSubmitter';

/** Banner mostrato su login/registrazione quando c'è una richiesta compilata dalla landing. */
export const PendingRequestBanner = ({ mode }) => {
  const pending = readPendingRequest();
  if (!pending?.payload) return null;

  const count = pending.payload?.selected_professional_ids?.length || 0;

  return (
    <div
      className="mb-6 rounded-2xl border border-primary/25 bg-primary/5 p-5 flex gap-3 items-start"
      data-testid="pending-request-banner"
    >
      <CheckCircle size={26} weight="duotone" className="text-primary shrink-0 mt-0.5" />
      <div>
        <p className="font-heading font-medium text-foreground">
          La tua richiesta è stata presa in carico
        </p>
        <p className="text-sm text-foreground/70 mt-1">
          {count > 0
            ? `Abbiamo salvato la richiesta per ${count} professionist${count > 1 ? 'i' : 'a'} selezionat${count > 1 ? 'i' : 'o'}. `
            : 'Abbiamo salvato i dati che hai inserito. '}
          {mode === 'login'
            ? 'Accedi per inviarla e vedere l’esito della richiesta.'
            : 'Completa la registrazione per inviarla e seguire gli esiti in tempo reale.'}
        </p>
      </div>
    </div>
  );
};

export default PendingRequestBanner;
